import { Provider } from '../../Models/DTO/Provider.model';
import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { isActionValid } from '~/Helpers/Reducer.helper';

const INITIAL_STATE = {
  provider: null,
  loading: false,
  error: null,
};

type CurrentProviderState = {
  provider: Provider | null;
  loading: boolean;
  error: IErrorResponse | null;
};

const useValidActions = isActionValid([
  REQUEST_ACTIONS.GET_PROVIDER,
  REQUEST_ACTIONS.UPDATE_PROVIDER,
]);

export default (
  state: CurrentProviderState = INITIAL_STATE,
  { name, status, payload }: INeoAction,
): CurrentProviderState => {
  const actionValid = useValidActions(name);

  if (actionValid) {
    if (status === STATUS.SUCCESS) {
      if (payload) {
        const provider = !!payload.provider ? payload.provider : payload;
        return {
          provider,
          loading: false,
          error: null,
        };
      }
      return {
        provider: payload?.provider || payload,
        loading: false,
        error: null,
      };
    } else if (status === STATUS.FAILURE) {
      return {
        provider: name === REQUEST_ACTIONS.UPDATE_PROVIDER ? state.provider : null,
        loading: false,
        error: payload || { message: 'Provider Error' },
      };
    } else if (status === STATUS.LOADING) {
      return {
        provider: state?.provider,
        loading: true,
        error: null,
      };
    }
  }

  return state;
};
